module.exports = __webpack_public_path__ + "static/ArmoryTCLogo-Small-fa12a3daf426fa992b32f240b246b171.png";